import type { MobileCtaMode } from '../types/StripeFeatures';
import type { CheckoutUrlRootBuilder } from './CheckoutUrlRootBuilder';
import { ExpressCheckoutPreferences } from './ExpressCheckoutPreferences';
import { PaymentElementPreferences } from './PaymentElementPreferences';

/** Presentation / payment-surface preferences for the checkout. */
export class CheckoutPreferences {
  constructor(private readonly root: CheckoutUrlRootBuilder) {}

  /** Configure the Express Checkout Element. */
  eco(configure: (eco: ExpressCheckoutPreferences) => void): this {
    configure(new ExpressCheckoutPreferences(this.root));
    return this;
  }

  /** Card/debit only — hide wallets and alternative payment methods. */
  ccOnly(on = true): this {
    this.root.param('cc_only', on ? '1' : undefined);
    return this;
  }

  /** Configure the on-page Stripe PaymentElement. */
  spe(configure: (spe: PaymentElementPreferences) => void): this {
    configure(new PaymentElementPreferences(this.root));
    return this;
  }

  /** Enable Stripe Link. */
  linkPay(on: boolean): this {
    this.root.param('link_pay', on ? '1' : undefined);
    return this;
  }

  /** How the order CTA sits on mobile. */
  mobileCta(mode: MobileCtaMode): this {
    this.root.param('mobile_cta', mode);
    return this;
  }

  /** Embedded (iframe) mode — no page margins / rounded corners. */
  embedded(on = true): this {
    this.root.param('embedded', on ? '1' : undefined);
    return this;
  }
}
